<div class="welcome-screen">
  <div class="welcome-card">
    <img class="welcome-logo" src="/assets/img/logo.svg" alt="Logo"/>
    <h1 class="welcome-title">Standards Orientation Tool</h1>
    <p class="welcome-subtitle">Please select a section in the sidebar</p>
  </div>
</div>
